<!--
Voting redirect screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="Voting" :back="1===2"/>
  </div>
</template>

<script setup>
//Utilities
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()

onMounted(
  () => {
    router.push('/voting/login/')
  }
)
</script>
